import { useCallback, useContext, useEffect, useRef, useState } from 'react';
import { deleteNotificationAdmin, getNotificationsAdmin } from '../../../../services/apis/notification';
import { convertDate, toastConfig } from '../../../../helpers/helper';
import ReactPaginate from 'react-paginate';
import { Button } from '../../../../components';
import { useNavigate } from 'react-router-dom';
import { FaEdit, FaPlus, FaTimes, FaTrash } from 'react-icons/fa';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';

const Notifications=()=>{
    const navigate = useNavigate()
    const {t} = useTranslation()
    const [notifications, setNotifications] = useState([]);  
    const [loading, setLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(0);
    const [totalPages, setTotalPages] = useState(null);


    const type=(data)=>{
      if(data == "ONE_TIME"){
          return t("adminNotification.add.oneTime")
      }else{
          return t("adminNotification.add.moreTime")
      }
    }

    // t("adminNotification.add.chooseUsers")
    // <div className='grid grid-cols-1 gap-2 w-[100%]'>{users.map((user,index)=>(
    //   <div key={index} className='bg-green-300 rounded-[12px] shadow-md w-[100%]'>{user.fullName ?? user.phone}</div>
    // ))}</div>
    const typeReceipnt=(data,users)=>{
        if(data == "CUSTOM_USERS"){
            return t("adminNotification.add.chooseUsers")
        }if(data == "ALL_BUYERS"){
            return t("adminNotification.add.buyers")
        }if(data == "ALL_USERS"){
          return t("adminNotification.add.allUsers")
        }else{
          return t("adminNotification.add.mediators")
        }
      }


    const typeFrequency=(data)=>{
        if(data == "DAILY"){
            return t("adminNotification.add.daily")
        }if(data == "EVERY_2_DAYS"){
            return t("adminNotification.add.twoDays")
        }if(data == "EVERY_3_DAYS"){
            return t("adminNotification.add.threeDays")
        }if(data == "EVERY_4_DAYS"){
            return t("adminNotification.add.fourDays")
        }if(data == "EVERY_5_DAYS"){
            return t("adminNotification.add.fiveDays")
        }if(data == "daiEVERY_6_DAYSly"){
            return t("adminNotification.add.sixDays")
        }if(data == "WEEKLY"){
            return t("adminNotification.add.weekly")
        }if(data == "EVERY_2_WEEK"){
            return t("adminNotification.add.twoWeek")
        }if(data == "MONTHLY"){
            return t("adminNotification.add.montly")
        }
      }


      const fetchNotifications = async (page) => {
        setLoading(true);
    
        try {

 
          const response = await getNotificationsAdmin("",page,20);
    
          const newOrders = response.data.page.content;
          setTotalPages(response.data.page.totalPages)
          setNotifications(newOrders)
        } catch (error) {
          console.error('Error fetching posts:', error);
        } finally {
          setLoading(false);
        }
      };


      useEffect(() => {
        fetchNotifications(currentPage);
      }, [currentPage]);

      const formatDateTime = (item) => {
        const date = new Date(item);
        return date.toLocaleString(); 
      };


      const handlePageClick = (selectedItem) => {
        setCurrentPage(selectedItem.selected);
      };


      const removeNotification = async (id) => {
        try {
          const response = await deleteNotificationAdmin('', id);
          fetchNotifications()
          toast.success(
            t("adminNotification.list.deleteNotification"),
            toastConfig,
          );
        } catch (error) {
        //   toast.error(error.response.data, toastConfig);
        }
      };
    return(
        <div className="bg-gradient-to-b from-[#FFFFFF] to-[#D7E2FF] p-10">
            <div className="w-[90%] mr-auto ml-auto">
        <div className='flex flex-row-reverse'>
         <Button title={t("adminNotification.list.buttonAdd")} onClick={()=>navigate("/admin/notifications/add",{state:{data:null}})} dark={true}/> 
         </div>   
        <div className="overflow-x-auto mt-5">
        <table className="min-w-full border border-gray-300 rounded-lg shadow-lg">
          <thead className="bg-[#3E0292] text-white">
            <tr>
              <th className="px-6 py-3 text-center text-md font-500">{t("adminNotification.list.number")}</th>
              <th className="px-6 py-3 text-center text-md font-500">{t("adminNotification.list.notification")}</th>
              <th className="px-6 py-3 text-center text-md font-500">{t("adminNotification.list.typeReceipnt")}</th>
              <th className="px-6 py-3 text-center text-md font-500">{t("adminNotification.list.type")}</th>
              <th className="px-6 py-3 text-center text-md font-500">{t("adminNotification.list.frequency")}</th>
              <th className="px-6 py-3 text-center text-md font-500">{t("adminNotification.list.schedualed")}</th>
              <th className="px-6 py-3 text-center text-md font-500">{t("adminNotification.list.date")}</th>
              <th className="px-6 py-3 text-center text-md font-500">{t("adminNotification.list.others")}</th>
            </tr>
          </thead>
          <tbody>
            {notifications.map((notification, index) => (
              <tr
                // ref={index === notifications.length - 1 ? lastItemRef : null}
                key={notification.id}
                className={`border-b ${index % 2 === 0 ? "bg-gray-100" : "bg-white"} hover:bg-gray-200`}
              >
                <td className="px-6 py-3 text-[#3E0292] text-sm font-700 cursor-pointer" onClick={()=>navigate(`/admin/notifications/${notification.id}`)}>{notification.id}</td>
                <td className="px-6 py-3 text-sm font-400 cursor-pointer" onClick={()=>navigate(`/admin/notifications/${notification.id}`)}>{notification.text}</td>
                <td className="py-3 text-sm font-400 text-center">{typeReceipnt(notification?.recipientType,notification?.customUsers)}</td>
                <td className="px-6 py-3 text-sm font-400">{type(notification.type)}</td>
                <td className="px-6 py-3 text-sm font-400">{typeFrequency(notification.recurrenceFrequency)}</td>
                <td className="px-6 py-3 text-sm font-400">{formatDateTime(notification.scheduledTime)}</td>
                <td className="px-6 py-3 text-sm font-400">{formatDateTime(notification.createdAt)}</td>
                <td className="px-6 py-3 text-sm font-400">
                    <div className='flex flex-row justify-around items-center'>
                        <FaTrash className='text-red-600 text-[20px] cursor-pointer' onClick={()=>removeNotification(notification.id)}/>
                        <FaEdit className='text-green-600 text-[20px] cursor-pointer mx-5' onClick={()=>navigate(`/admin/notifications/${notification.id}/edit`,{state:{data:notification}})}/>
                        <FaPlus className='text-blue-600 text-[20px] cursor-pointer' onClick={()=>navigate(`/admin/notifications/add`,{state:{data:notification}})}/>
                    </div>
                </td>


              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {!notifications || notifications.length == 0 ? null : (
        <ReactPaginate
        previousLabel={"<"}
        nextLabel={">"}
        breakLabel={"..."}
        pageCount={totalPages}
        marginPagesDisplayed={2}
        pageRangeDisplayed={5}
        onPageChange={handlePageClick}
        // containerClassName={"pagination"}
        // activeClassName={"active"}
        containerClassName="flex justify-center items-center space-x-2 mt-4"
        pageClassName="bg-white border border-[#3E0292] rounded p-2 hover:bg-gray-200"
        activeClassName="bg-[#3E0292] text-[#3E0292] p-2 rounded"
        previousClassName="bg-white border border-[#3E0292] rounded p-2 hover:bg-gray-200"
        nextClassName="bg-white border border-[#3E0292] rounded p-2 hover:bg-gray-200"
        disabledClassName="text-gray-400 cursor-not-allowed"
        breakClassName="bg-white border border-gray-300 rounded p-2 hover:bg-gray-200"
      />)}
      </div>
      </div>
    )
}

export default Notifications